import React from 'react';
import { useVideosData } from './useVideosData';
import { PageHead } from '../Layout';
import {
  cssColorValue,
  KeyboardDetectionProvider,
  TabItem,
  TabList,
  Tabs,
  Text,
  cssSpacing,
} from '@spotify-internal/encore-web';
import { Grid } from '@spotify-internal/frodor-modules';
import styled from 'styled-components';
import { CategoriesTabPanel } from './CategoriesTabPanel';
import { HeaderTabPanel } from './HeaderTabPanel';
import { InteractiveElement } from '../../utils/InteractiveElement';

const TabsWrapper = styled.div`
  grid-column: 1 / -1;
  overflow: scroll;
  padding-block: ${cssSpacing('looser-4')};
`;
const StyledTabs = styled(Tabs)`
  background-color: ${cssColorValue('backgroundBase')};
  background-color: ${cssColorValue('backgroundBase')};
`;

export const Videos = () => {
  const { videoCategories, videos, socialCard } = useVideosData();
  if (!videos || !videoCategories) {
    return null;
  }
  return (
    // can remove keyboard detection when switch to new page
    <KeyboardDetectionProvider>
      <PageHead title="Videos" image={socialCard} />
      <StyledTabs className="encore-base-set">
        <HeaderTabPanel />
        <Grid>
          <TabsWrapper>
            <TabList aria-label="Video Categories">
              {videoCategories.allSlugs.map((slug: string) => {
                const id = videoCategories.slugToId[slug];
                const category = videoCategories.byId[id];
                return (
                  <InteractiveElement
                    customComponent={TabItem}
                    key={`${category.name}-tab-keyboard`}
                    value={category.id}
                    trackingLabel={`Category tab - ${category.name}`}
                    trackingCategory="Videos"
                  >
                    <Text variant="bodyMediumBold">{category.name}</Text>
                  </InteractiveElement>
                );
              })}
            </TabList>
          </TabsWrapper>
        </Grid>
        <CategoriesTabPanel />
      </StyledTabs>
    </KeyboardDetectionProvider>
  );
};
